import { useCallback, useEffect } from 'react';
import { useSearch } from 'shared/helpers/hooks';
import { getTokenAuthParams } from 'shared/utils/user';
import useLogin from 'shared/Providers/User/use-login';
import { Typography } from '@mui/material';

export default function OAuthPage() {
	const queryParams = useSearch();
	const { setToken } = useLogin();

	const handleAuth = useCallback(async () => {
		const authResponse = getTokenAuthParams(queryParams);
		if (authResponse) {
			const nextPage = queryParams.next as string;
			setToken(authResponse);
			window.location.href = nextPage ?? '/projects';
		}
	}, [queryParams, setToken]);

	useEffect(() => {
		handleAuth();
	}, []);

	return (
		<Typography
			sx={{
				textAlign: 'center',
			}}
		>
			authorization ...
		</Typography>
	);
}
